export enum TabsEnum {
    CREATE_TAB = 'create_tab',
    SYNC_TAB = 'sync_tab',
    DELETE_TAB = 'delete_tab',
}
